import React from 'react';
import '../styles/Partenaires.css';
import '../styles/Horaires.css';
import '../styles/AppAgt.css';
import '../styles/PresentationHomogene.css';
import Footer from '../components/Footer';
import OuvrirFenetrePartenaire from '../components/OuvrirFenetrePartenaire';
import OuvrirFenetrePartenaireAvecOption from '../components/OuvrirFenetrePartenaireAvecOption';

const Partenaires = () => {
    return (
        <div className='AppAgt'>
            {/* Titre simple sous le header */}
            <div className='horaires-header-simple'>
                <h1 className='horaires-main-title'>Nos Partenaires</h1>
                <p className='horaires-main-description'>
                    Découvrez, par ordre alphabétique, les organisations et institutions qui nous
                    accompagnent dans la valorisation du patrimoine et du tourisme dans le Vendomois             </p>
            </div>

            {/* Section principale avec style de l'accueil */}
            <div className='Presentation'>
                {/* Partenaires Institutionnels */}
                <div className='presentation-section'>
                    <div className='presentation-card partenaires-institutionnels'>
{/*                        <div className='section-header institutionnels-header'>
                            <h2 className='section-title'>🏛️ Partenaires Institutionnels</h2>
                        </div> */}
 
                        <div className='section-content'>
                            <div className='partenaires-grid partenaires-with-separators'>
 
                                <div className='partenaire-item'>
                                    <OuvrirFenetrePartenaire 
                                        imageUrl="ImgPartenaires/logoCdt.png" 
                                        sitePartenaire="https://association-au-coeur-de-troo.jimdosite.com"
                                        classPartenaire='partenaire-logo'
                                        altPartenaire='Association Au Cœur de Trôo'
                                    />
                                    <h3>Au Cœur de Trôo</h3>
                                    <p>Association locale de valorisation du patrimoine de Trôo</p>
                                </div>

                                <div className='partenaire-separator'></div>

                               <div className='partenaire-item'>
                                    <OuvrirFenetrePartenaire 
                                        imageUrl="/ImgPartenaires/CadeauWeb.jpg" 
                                        sitePartenaire="https://www.cadeauweb.fr/"
                                        classPartenaire='partenaire-logo'
                                        altPartenaire='Cadeau Web'
                                    />
                                    <h3>Cadeau Web</h3>
                                    <p>Un de nos fournisseurs pour les objets que vous pourrez trouver dans notre boutique</p>
                                </div>

                                <div className='partenaire-separator'></div>

                                  <div className='partenaire-item'>
                                    <OuvrirFenetrePartenaire 
                                        imageUrl="ImgPartenaires/CaveCyril.jpg" 
                                        sitePartenaire="https://www.facebook.com/lacavedecyril41/?locale=fr_FR"
                                        classPartenaire='partenaire-logo'
                                        altPartenaire='Association Au Cœur de Trôo'
                                    />
                                    <h3>La Cave de Cyril</h3>
                                    <p>Notre fournisseur de gourmandises à base de Champignons </p>                              </div>

                                <div className='partenaire-separator'></div>     

                                <div className='partenaire-item'>
                                    <OuvrirFenetrePartenaire 
                                        imageUrl="/ImgPartenaires/logoEsat.jpg" 
                                        sitePartenaire="https://www.esat-apf-jeanmuriel.fr/"
                                        classPartenaire='partenaire-logo'
                                        altPartenaire='ESAT Jean Muriel de Lunay'
                                    />
                                    <h3>ESAT Jean Muriel Lunay</h3>
                                    <p>Un de nos fournisseurs pour les objets que vous pourrez trouver dans notre boutique</p>
                                </div>

                                <div className='partenaire-separator'></div>

                                <div className='partenaire-item'>
                                    <OuvrirFenetrePartenaire 
                                        imageUrl="/ImgPartenaires/FermeCharlin.png" 
                                        sitePartenaire="https://lafermedecharlin.fr/"
                                        classPartenaire='partenaire-logo'
                                        altPartenaire='Ferme de Charlin'
                                    />
                                    <h3>Ferme de Charlin</h3>
                                    <p>Ferme biologique du Vendomois : Un de nos fournisseurs pour nos gourmandises</p>

                                </div>
                                <div className='partenaire-separator'></div>

                                <div className='partenaire-item'>
                                    <OuvrirFenetrePartenaire 
                                        imageUrl="/ImgPartenaires/logoHistorius.jpg" 
                                        sitePartenaire="https://www.historius-montoire.fr/"
                                        classPartenaire='partenaire-logo'
                                        altPartenaire='HistOrius Montoire'
                                    />
                                    <h3>Hist'Orius</h3>
                                    <p>Association historique locale de Montoire et de ses environs</p>
                                </div>

                                <div className='partenaire-separator'></div>

                                <div className='partenaire-item'>
                                    <OuvrirFenetrePartenaire 
                                        imageUrl="/ImgPartenaires/logoLoirDecouvertes.jpg" 
                                        sitePartenaire="https://loirdecouvertes.fr/"
                                        classPartenaire='partenaire-logo'
                                        altPartenaire='Loir Découvertes'
                                    />
                                    <h3>Loir Découvertes</h3>
                                    <p>Organisateur de circuits de découvertes à vélo dans le Vendômois</p>
                                </div>

                                <div className='partenaire-separator'></div>
 
                                <div className='partenaire-item'>
                                    <OuvrirFenetrePartenaire 
                                        imageUrl="/ImgPartenaires/logoMaisonGigou.png" 
                                        sitePartenaire="https://www.bienvenue-a-la-ferme.com/centre/loir-et-cher/bonneveau/ferme/earl-maison-gigou/192393"
                                        classPartenaire='partenaire-logo'
                                        altPartenaire='Maison Gigou'
                                    />
                                    <h3>Maison Gigou</h3>
                                    <p>Notre fournisseur de terrines</p>
                                </div>

                                <div className='partenaire-separator'></div>


                                <div className='partenaire-item'>
                                    <OuvrirFenetrePartenaire 
                                        imageUrl="/ImgPartenaires/logoOtv.jpg" 
                                        sitePartenaire="https://www.vendome-tourisme.fr/"
                                        classPartenaire='partenaire-logo'
                                        altPartenaire='Office de Tourisme Vendôme'
                                    />
                                    <h3>Office de Tourisme</h3>
                                    <p>Promotion touristique de la région</p>
                                </div>

                                <div className='partenaire-separator'></div>

                                <div className='partenaire-item'>
                                     <OuvrirFenetrePartenaire 
                                        imageUrl="ImgPartenaires/PNA41.jpg" 
                                        sitePartenaire="https://www.pnafrance.fr/"
                                        classPartenaire='partenaire-logo'
                                        altPartenaire='Notre fourniseeur de miel local'
                                    />
                                    <h3>PNA 41</h3>
                                    <p>Notre Fournisseur de miel local</p>
                                </div>

                                <div className='partenaire-separator'></div>

                                <div className='partenaire-item'>
                                    <OuvrirFenetrePartenaire 
                                        imageUrl="/ImgPartenaires/PoleImage41.png" 
                                        sitePartenaire="https://poleimage41.fr/"
                                        classPartenaire='partenaire-logo'
                                        altPartenaire='Pôle Image 41'
                                    />
                                    <h3>Pôle Image 41</h3>
                                    <p>Association audiovisuel locale</p>
                                </div>

                                <div className='partenaire-separator'></div>

                                <div className='partenaire-item'>
                                    <OuvrirFenetrePartenaireAvecOption
                                        imageUrl="/ImgPartenaires/logoTerritoiresVendomois.jpg" 
                                        sitePartenaire="https://www.territoiresvendomois.fr/"
                                        classPartenaire='partenaire-logo'
                                        altPartenaire='Territoires Vendomois'
                                    />
                                    <h3>Territoires Vendomois</h3>
                                    <p>Communauté d'agglomération de communes du Vendomois</p>
                                </div>

                                <div className='partenaire-separator'></div>

                                <div className='partenaire-item featured'>
                                    <OuvrirFenetrePartenaire 
                                        imageUrl="/ImgPartenaires/logo-ttvl.png" 
                                        sitePartenaire="https://www.ttvl.fr/"
                                        classPartenaire='partenaire-logo-large'
                                        altPartenaire='Train Touristique de la Vallée du Loir'
                                    />
                                    <h3>Train Touristique TTVL</h3>
                                    <p>Notre partenaire ferroviaire principal pour les voyages patrimoniaux</p>
                                </div>

                                <div className='partenaire-separator'></div>

                                <div className='partenaire-item'>
                                    <OuvrirFenetrePartenaire 
                                        imageUrl="/ImgPartenaires/logoToutourisme.png" 
                                        sitePartenaire="https://toutourismefrance.jimdofree.com/"
                                        classPartenaire='partenaire-logo'
                                        altPartenaire='Toutourisme'
                                    />
                                    <h3>Toutourisme</h3>
                                    <p>Label d'accueil des chiens dans les sites touristiques</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default Partenaires;